<template>
    <div class="min-basket-value">
        <div v-if="percent < 100" class="text-center">
            {{ $translate("Woerner::Template.minBasketValue") }}
        </div>
        <div class="progress mt-2">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+percent+'%'" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="mt-2 text-center color-green" v-if="percent >= 100">
            <i class="fa fa-check-circle-o mr-1"></i> {{ $translate("Woerner::Template.minBasketValueReached") }}
        </div>
        <div class="mt-2 text-center color-green" v-else>
            {{ $translate("Woerner::Template.minBasketValueDiff") }} {{ diff | currency }} {{ $translate("Woerner::Template.minBasketValueDiffTextAfter") }}
        </div>
        {{percentcalc}}
    </div>
</template>

<script>
    export default
    {
        props: ['template'],
        data: function()
        {
            return{
                percent           : 0,
                itemSumNet        : 0,
                deliverycountryid : 0,
                diff:0
            }
        },
        mounted()
        {
            this.getBasketValueAndShippingId();
        },
        methods:
            {
                getBasketValueAndShippingId: function()
                {
                    let _self               = this;
                    // Prüfung DE / AT / CH
                    if(this.$store.state.basket.data.shippingCountryId == 1 || this.$store.state.basket.data.shippingCountryId== 2 ||  this.$store.state.basket.data.shippingCountryId == 4)
                    {
                        _self.percent           = ((this.$store.state.basket.data.itemSumNet / 30) * 100);
                        _self.diff              = 30-this.$store.state.basket.data.itemSumNet;
                    }
                    else
                    {
                        _self.percent           = ((this.$store.state.basket.data.itemSumNet / 100) * 100);
                        _self.diff              = 100-this.$store.state.basket.data.itemSumNet;
                    }
                    _self.itemSumNet        =  this.$store.state.basket.data.itemSumNet;
                }
            },
        computed:
            {
                percentcalc: function()
                {
                    return this.getBasketValueAndShippingId();
                },
            }
    }
</script>
